// Chat analytics
var intervalShopifyChat = null;
intervalShopifyChat = setInterval(function() {
    if (jQuery("#ShopifyChat").length > 0) {
        clearInterval(intervalShopifyChat);
        jQuery("#ShopifyChat").on("load", function(evt) {
          jQuery(this).contents().on("click", ".customer-info-form__online-container button", function (evt) {
            window.dataLayer.push({
              "event": "Start chat"
            });
          });
        });
    }
}, 100);

function waitForElement(id, callback){
    var poops = setInterval(function(){
        if(document.getElementById(id)){
            clearInterval(poops);
            callback();
        }
    }, 100);
}

waitForElement("calculator", function(){
   
    
  // if(document.querySelector(".swatch-label input[value='Børstet']")){
    
  // document.querySelector(".swatch-label input[value='Børstet']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Børstet'] input[value='Klar glas']").onchange();
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Børstet']  input[value='Klar glas']").click();
    
  // })
  // }
  //  if(document.querySelector(".swatch-label input[value='Blank Krom']")){
  // document.querySelector(".swatch-label input[value='Blank Krom']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Blank Krom'] input[value='Klar glas']").onchange()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Blank Krom'] input[value='Klar glas']").click()
  // })
  //  }
  //  if(document.querySelector(".swatch-label input[value='Messing']")){
  // document.querySelector(".swatch-label input[value='Messing']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Messing'] input[value='Klar glas']").onchange()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Messing'] input[value='Klar glas']").click()
  // })

  //  }
  //  if(document.querySelector(".swatch-label input[value='Sort']")){
  // document.querySelector(".swatch-label input[value='Sort']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Sort'] input[value='Klar glas']").onchange()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Sort'] input[value='Klar glas']").click()
  // })
    //  }
  //  if(document.querySelector(".swatch-label input[value='Børstet Kobber']")){
  // document.querySelector(".swatch-label input[value='Børstet Kobber']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Børstet Kobber'] input[value='Klar glas']").onchange()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Børstet Kobber'] input[value='Klar glas']").click()
  // })
   
  //  }                                 
    
  if (document.querySelector("input[data-identifier='Profilfarve']")) {
    document.querySelectorAll("input[data-identifier='Profilfarve']").forEach(function (element) {
      element.addEventListener('click', function() {
       //document.querySelector(".thumbnail-list").querySelector("button").click()
       // document.querySelector(".product__thumbnail-list-inner").querySelector("button").click()
        document.querySelector("#calculator .element[data-conditionalelementvalue='"+ this.value +"'] input[value='Klar glas']").onchange()
        document.querySelector("#calculator .element[data-conditionalelementvalue='"+ this.value +"'] input[value='Klar glas']").click()
      })
    })
  }
      
  if (document.querySelector("input[data-identifier='Profilfarve med profilramme']")) {
    document.querySelectorAll("input[data-identifier='Profilfarve med profilramme']").forEach(function (element) {
      element.addEventListener('click', function() {
       //document.querySelector(".thumbnail-list").querySelector("button").click()
       // document.querySelector(".product__thumbnail-list-inner").querySelector("button").click()
        document.querySelector("#calculator .element[data-conditionalelementvalue='"+ this.value +"'] input[value='Klar glas']").onchange()
        document.querySelector("#calculator .element[data-conditionalelementvalue='"+ this.value +"'] input[value='Klar glas']").click()
      })
    })
  }
  
  if (document.querySelector("input[value='Klar Jernfattig'], input[value='Klar glas'], input[value='Materet glas'], input[value='Røgfarvet glas'], input[value='Bronzefarvet glas'], input[value='Striped 3D']")) {
    document.querySelectorAll("input[value='Klar Jernfattig'], input[value='Klar glas'], input[value='Materet glas'], input[value='Røgfarvet glas'], input[value='Bronzefarvet glas'], input[value='Striped 3D']").forEach(function (element) {
      element.addEventListener('click', function() {
       // document.querySelector(".product__thumbnail-list-inner").querySelector("button").click()
       // document.querySelector(".thumbnail-list").querySelector("button").click()
      })
    })
  }
  
});
waitForElement("calculator", function(){
   
    
  // if(document.querySelector(".swatch-label input[value='Børstet']")){
    
  // document.querySelector(".swatch-label input[value='Børstet']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Børstet'] input[value='Klar glas']").onchange();
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Børstet']  input[value='Klar glas']").click();
    
  // })
  // }
  //  if(document.querySelector(".swatch-label input[value='Blank Krom']")){
  // document.querySelector(".swatch-label input[value='Blank Krom']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Blank Krom'] input[value='Klar glas']").onchange()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Blank Krom'] input[value='Klar glas']").click()
  // })
  //  }
  //  if(document.querySelector(".swatch-label input[value='Messing']")){
  // document.querySelector(".swatch-label input[value='Messing']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Messing'] input[value='Klar glas']").onchange()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Messing'] input[value='Klar glas']").click()
  // })

  //  }
  //  if(document.querySelector(".swatch-label input[value='Sort']")){
  // document.querySelector(".swatch-label input[value='Sort']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Sort'] input[value='Klar glas']").onchange()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Sort'] input[value='Klar glas']").click()
  // })
    //  }
  //  if(document.querySelector(".swatch-label input[value='Børstet Kobber']")){
  // document.querySelector(".swatch-label input[value='Børstet Kobber']").addEventListener('click', function() {
  //   document.querySelector(".thumbnail-list").querySelector("button").click()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Børstet Kobber'] input[value='Klar glas']").onchange()
  //   document.querySelector("#calculator .element[data-conditionalelementvalue='Børstet Kobber'] input[value='Klar glas']").click()
  // })
   
  //  }                                 
    
      
  if (document.querySelector("input[data-identifier='Profilfarve med profilramme']")) {
    document.querySelectorAll("input[data-identifier='Profilfarve med profilramme']").forEach(function (element) {
      element.addEventListener('click', function() {
       //document.querySelector(".thumbnail-list").querySelector("button").click()
       // document.querySelector(".product__thumbnail-list-inner").querySelector("button").click()
        document.querySelector("#calculator .element[data-conditionalelementvalue='"+ this.value +"'] input[value='Klar glas']").onchange()
        document.querySelector("#calculator .element[data-conditionalelementvalue='"+ this.value +"'] input[value='Klar glas']").click()
      })
    })
  }
  
  if (document.querySelector("input[value='Klar Jernfattig'], input[value='Klar glas'], input[value='Materet glas'], input[value='Røgfarvet glas'], input[value='Bronzefarvet glas'], input[value='Striped 3D']")) {
    document.querySelectorAll("input[value='Klar Jernfattig'], input[value='Klar glas'], input[value='Materet glas'], input[value='Røgfarvet glas'], input[value='Bronzefarvet glas'], input[value='Striped 3D']").forEach(function (element) {
      element.addEventListener('click', function() {
       // document.querySelector(".product__thumbnail-list-inner").querySelector("button").click()
       // document.querySelector(".thumbnail-list").querySelector("button").click()
      })
    })
  }
  
});
  

class TermsAndConditions extends HTMLElement {
    constructor() {
        super();      
      	this.Binds();
    }
  
    Binds () {
      var self = this;
      this.parentNode.querySelector('#checkout').addEventListener("click", function (event) {
        if (!this.parentNode.querySelector('#enable_terms').checked) {
          event.preventDefault(); 
          
          var container = this.parentNode.querySelector('#enable_terms').parentNode.parentNode;
          
          if (container.querySelector('.error') == null) {
            var error = document.createElement('p');
            error.classList.add('error');
            error.innerHTML = "Dette felt er påkrævet";
            container.appendChild(error);
            
            if (!self.is_terms_bound) {
              this.parentNode.querySelector('#enable_terms').addEventListener('change', function () {
                if (container.querySelector('.error')) {
                  container.querySelector('.error').parentNode.removeChild(container.querySelector('.error'));
                }
              }, true);
              self.is_terms_bound = true;
            }
          }
        } 
      });
    }
}

customElements.define("terms-and-conditions", TermsAndConditions);

